import React, { useEffect, useState } from 'react'
import Container from '../../Container/Container'
import { useNavigate } from 'react-router'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { get } from '../../ApiServices/ApiServices';
import moment from 'moment';
import Loader from '../Component/Loader';
import CancelFun from '../Component/CancelFun';
import { useDispatch, useSelector } from 'react-redux';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

function Wedding() {
	const [weddingOrder, setWeddingOrder] = useState([]);
	const [count, setCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [searchTerm, setSearchTerm] = useState('');
	const [totalPages, setTotalPages] = useState(1);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const profile = useSelector((state) => state.profile.profile);
	const [selectedStatus, setSelectedStatus] = useState("");
	const [refreshKey, setRefreshKey] = useState(0);

	// Separate state for Order Date filter
	const [orderDateFilter, setOrderDateFilter] = useState({
		startDate: '',
		endDate: ''
	});
	const [orderDateRange, setOrderDateRange] = useState({
		startDate: null,
		endDate: null,
	});
	const [orderDisplayLabel, setOrderDisplayLabel] = useState('');

	// Separate state for Wedding Date filter
	const [weddingDateFilter, setWeddingDateFilter] = useState({
		startDate: '',
		endDate: ''
	});
	const [weddingDateRange, setWeddingDateRange] = useState({
		startDate: null,
		endDate: null,
	});
	const [weddingDisplayLabel, setWeddingDisplayLabel] = useState('');

	// Order Date handlers
	const handleOrderDateApply = (event, picker) => {
		const startDate = picker.startDate;
		const endDate = picker.endDate;

		setOrderDateRange({ startDate, endDate });
		setOrderDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);
		setOrderDateFilter({
			startDate: startDate.format('YYYY-MM-DD'),
			endDate: endDate.format('YYYY-MM-DD')
		});
		setCurrentPage(1);
	};

	const handleOrderDateCancel = (event, picker) => {
		setOrderDateRange({
			startDate: null,
			endDate: null,
		});
		setOrderDisplayLabel('');
		setOrderDateFilter({
			startDate: '',
			endDate: ''
		});

		// Reset the picker without destroying it
		if (picker) {
			picker?.setStartDate(moment());
			picker?.setEndDate(moment());
			picker?.updateView();
		}
		setCurrentPage(1);
	};

	// Wedding Date handlers
	const handleWeddingDateApply = (event, picker) => {
		const startDate = picker.startDate;
		const endDate = picker.endDate;

		setWeddingDateRange({ startDate, endDate });
		setWeddingDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);
		setWeddingDateFilter({
			startDate: startDate.format('YYYY-MM-DD'),
			endDate: endDate.format('YYYY-MM-DD')
		});
		setCurrentPage(1);
	};

	const handleWeddingDateCancel = (event, picker) => {
		setWeddingDateRange({
			startDate: null,
			endDate: null,
		});
		setWeddingDisplayLabel('');
		setWeddingDateFilter({
			startDate: '',
			endDate: ''
		});

		// Reset the picker without destroying it
		if (picker) {
			picker?.setStartDate(moment());
			picker?.setEndDate(moment());
			picker?.updateView();
		}
		setCurrentPage(1);
	};

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchTerm(value);
		setCurrentPage(1); // Reset to first page when searching
	};

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	const handleItemsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page when changing items per page
	};

	const onCancleSuccess = () => {
		getWeddingOrders(currentPage, itemsPerPage, searchTerm);
	};

	const handleStatusChange = (e) => {
		setSelectedStatus(e.target.value);
		setCurrentPage(1);
	};

	var status = [
		{
			"id": 1,
			"name": "Pending",
			"colour": "yellow",
			"createdAt": "2025-02-18T13:07:40.000Z",
			"updatedAt": null,
			"deletedAt": null
		},
		{
			"id": 2,
			"name": "Open",
			"colour": "orange",
			"createdAt": "2025-02-18T13:07:40.000Z",
			"updatedAt": null,
			"deletedAt": null
		},
		{
			"id": 3,
			"name": "Completed",
			"colour": "green",
			"createdAt": "2025-02-18T13:08:16.000Z",
			"updatedAt": null,
			"deletedAt": null
		},
		{
			"id": 4,
			"name": "Cancelled",
			"colour": "red",
			"createdAt": "2025-03-05T09:04:59.000Z",
			"updatedAt": null,
			"deletedAt": null
		}
	]

	const getWeddingOrders = async () => {
		setLoading(true);
		try {
			let api = `all-wedding-events?page_number=${currentPage}&size=${itemsPerPage}&search=${searchTerm}&status_id=${selectedStatus}`;

			// Add order date filters if they exist
			if (orderDateFilter.startDate && orderDateFilter.endDate) {
				api += `&order_start_date=${orderDateFilter.startDate}&order_end_date=${orderDateFilter.endDate}`;
			}

			// Add wedding date filters if they exist
			if (weddingDateFilter.startDate && weddingDateFilter.endDate) {
				api += `&start_date=${weddingDateFilter.startDate}&end_date=${weddingDateFilter.endDate}`;
			}

			const response = await get(api);

			if (response?.status === true) {
				setWeddingOrder(response.data?.rows || []);
				setCount(response.data?.count || 0);
				setTotalPages(Math.ceil(response.data?.count / itemsPerPage));
			}
		} catch (err) {
			if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
				localStorage.removeItem('token');
				navigate('/login');
			}
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getWeddingOrders();
	}, [currentPage, itemsPerPage, searchTerm, orderDateFilter, weddingDateFilter, selectedStatus]);

	return (
		<Container>
			<div className="nk-content ">
				<div className="container-fluid">
					<div className="nk-content-inner">
						<div className="nk-content-body">
							<div className="nk-block-head nk-block-head-sm pbZeroHeadin">
								<div className="nk-block-between">
									<div className="nk-block-head-content">
										<h3 className="nk-block-title page-title">Active Wedding Events</h3>
									</div>
									<div className="nk-block-head-content rightButtonAddWeedd">
										<div className="toggle-wrap nk-block-tools-toggle">
											<div className="toggle-expand-content" data-content="pageMenu">
												<ul className="nk-block-tools g-3">
													<li className="nk-block-tools-opt">
														<button
															className="btn btn-primary"
															onClick={() => navigate("/add-wedding-order")}
														>
															<span>Add Wedding Event</span>
														</button>
													</li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="card card-full WeddingPagesMain">
								<div className="card-inner">


									<div className="row">
										<div className="col-md-3">
											<div className="form-control-wrap customrSearch">
												<label style={{ fontWeight: 'bold' }}></label>
												<div className="form-icon form-icon-right">
													<em className="icon ni ni-search"></em>
												</div>
												<input
													type="text"
													className="form-control"
													placeholder="Search by keywords"
													value={searchTerm}
													onChange={handleSearch}
													style={{
														minWidth: '100%',
														border: '1px solid #dbdfea',
														color: '#35495e',
													}}
												/>
											</div>
										</div>

										<div className="col-md-3">
											<div className="form-control-wrap">
												<label style={{ fontWeight: 'bold' }}>
													Wedding Date
												</label>
												<DateRangePicker
													initialSettings={{
														startDate: orderDateRange.startDate || moment(),
														endDate: orderDateRange.endDate || moment(),
														locale: {
															format: 'MMM D, YYYY',
															cancelLabel: 'Clear',
															applyLabel: 'Apply',
														},
														ranges: {
															'Today': [moment(), moment()],
															'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
															'Last 7 Days': [moment().subtract(6, 'days'), moment()],
															'Last 30 Days': [moment().subtract(29, 'days'), moment()],
															'This Month': [moment().startOf('month'), moment().endOf('month')],
															'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
														},
														opens: 'right',
														autoApply: true,
														autoUpdateInput: true,
														alwaysShowCalendars: true,
														showCustomRangeLabel: true,
														showCancel: true,
													}}
													onApply={handleOrderDateApply}
													onCancel={handleOrderDateCancel}
												>
													<input
														type="text"
														className="form-control"
														placeholder="Select date range"
														value={orderDisplayLabel}
														readOnly
														style={{
															cursor: 'pointer',
															backgroundColor: '#fff',
															border: '1px solid #dbdfea',
															borderRadius: '4px',
															padding: '0.375rem 0.75rem',
															minWidth: '100%',
															paddingRight: '30px',
															color: '#35495e',
														}}
													/>
												</DateRangePicker>
												{orderDisplayLabel && (
													<span
														className="clear-icon"
														onClick={(e) => {
															e.stopPropagation();
															e.preventDefault();
															handleOrderDateCancel();
														}}
														style={{
															position: 'absolute',
															right: '10px',
															top: '70%',
															transform: 'translateY(-50%)',
															cursor: 'pointer',
															zIndex: 10
														}}
													>
														<em className="icon ni ni-cross"></em>
													</span>
												)}
											</div>
										</div>


										<div className="col-md-3">
											<div className="form-control-wrap">
												<label style={{ fontWeight: 'bold' }}>
													Order Date
												</label>
												<DateRangePicker
													initialSettings={{
														startDate: weddingDateRange.startDate || moment(),
														endDate: weddingDateRange.endDate || moment(),
														locale: {
															format: 'MMM D, YYYY',
															cancelLabel: 'Clear',
															applyLabel: 'Apply',
														},
														ranges: {
															'Today': [moment(), moment()],
															'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
															'Last 7 Days': [moment().subtract(6, 'days'), moment()],
															'Last 30 Days': [moment().subtract(29, 'days'), moment()],
															'This Month': [moment().startOf('month'), moment().endOf('month')],
															'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
														},
														opens: 'right',
														autoApply: true,
														autoUpdateInput: true,
														alwaysShowCalendars: true,
														showCustomRangeLabel: true,
														showCancel: true,
													}}
													onApply={handleWeddingDateApply}
													onCancel={handleWeddingDateCancel}
												>
													<input
														type="text"
														className="form-control"
														placeholder="Select date range"
														value={weddingDisplayLabel}
														readOnly
														style={{
															cursor: 'pointer',
															backgroundColor: '#fff',
															border: '1px solid #dbdfea',
															borderRadius: '4px',
															padding: '0.375rem 0.75rem',
															minWidth: '100%',
															paddingRight: '30px',
															color: '#35495e',
														}}
													/>
												</DateRangePicker>
												{weddingDisplayLabel && (
													<span
														className="clear-icon"
														onClick={(e) => {
															e.stopPropagation();
															e.preventDefault();
															handleWeddingDateCancel();
														}}
														style={{
															position: 'absolute',
															right: '10px',
															top: '70%',
															transform: 'translateY(-50%)',
															cursor: 'pointer',
															zIndex: 10
														}}
													>
														<em className="icon ni ni-cross"></em>
													</span>
												)}
											</div>
										</div>

										<div className="col-md-3">
											<div className="form-control-wrap">
												<label style={{ fontWeight: 'bold' }}>
													Order Status
												</label>
												<select
													className="form-control"
													value={selectedStatus}
													onChange={handleStatusChange}
													style={{
														minWidth: '100%',
														padding: "12px 16px",
														border: '1px solid #dbdfea',
														color: '#35495e',
														appearance: 'none',
														backgroundImage: "url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%2335495e%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')",
														backgroundRepeat: 'no-repeat',
														backgroundPosition: 'right 0.7rem top 50%',
														backgroundSize: '0.65rem auto',
													}}
												>
													<option value="">Filter by Active Status</option>
													<option value="">All</option>
													{
														status?.map((data) => (
															<option key={data.id} value={data.id}>
																{data.name}
															</option>
														))
													}
												</select>
											</div>
										</div>


									</div>




									{/* <div className='d-flex flex-wrap align-items-center mb-3' style={{ gap: '16px' }}>


										<div className="card-tools" style={{ flex: '1 0 -1px' }}>
											
										</div>

										
										<div className="card-tools" style={{ flex: '1 0 -1px' }}>
											
										</div>

										
										<div className="card-tools" style={{ flex: '1 0 -1px', marginLeft: "69px" }}>
											
										</div>

										
										<div className="card-tools" style={{ flex: '20 0 -1px', marginLeft: "69px" }}>
											
										</div>
									</div> */}

									{loading ? (
										<div className="text-center py-5">
											<Loader />
										</div>
									) : (
										<>
											<div className="table-responsive">
												<table className="table table-striped">
													<thead>
														<tr>
															<th scope="col">Wedding Date</th>
															<th scope="col">Acct</th>
															<th scope="col">Groom's Name</th>
															<th scope="col">Bride's Name</th>
															<th scope="col">Order Date</th>
															<th scope="col">Order Status</th>
															<th scope="col">Submitted By</th>
															<th scope="col">Action</th>
														</tr>
													</thead>
													<tbody>
														{weddingOrder.length > 0 ? (
															weddingOrder.map((data) => (
																<tr key={data.id}>
																	<td className="tableMinWidth120">{data?.wedding_date && moment(data?.wedding_date).format("MMM D, YYYY")}</td>
																	<td className="tableMinWidth120">{data?.user?.account}</td>
																	<td className="tableMinWidth120">{data?.groom_first_name} {data?.groom_last_name}</td>
																	<td className="tableMinWidth120">{data?.bride_first_name} {data?.bride_last_name}</td>
																	<td className="tableMinWidth">{moment(data?.createdAt).format("MMM D, YYYY")}</td>
																	<td className="tableMinWidth" style={{ textTransform: 'capitalize' }}>{data?.status?.name}</td>
																	<td className="tableMinWidth">{data?.submitted_by}</td>
																	<td className="tableActionBtn tLeftalign">
																		<button className="deleteTrash" onClick={() => navigate(`/wedding-event-detail`, { state: { eventId: data?.id } })}>
																			<em className="icon ni ni-eye"></em>
																		</button>


																		{
																			data?.status?.name != "cancelled" &&
																			<CancelFun url={`change-wedding-order-status/${data?.id}`} onCancleSuccess={onCancleSuccess} />
																		}
																	</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan="8" className="text-center">No wedding events found</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>

											{/* Pagination */}
											{count > 0 && (
												<div className="nk-block-between-md g-3 mt-3">
													<div className="g">
														<div className="pagination d-flex gap-2" style={{ height: "35px" }}>
															<button
																className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
																onClick={() => handlePageChange(currentPage - 1)}
																disabled={currentPage === 1}
															>
																Previous
															</button>

															{Array.from({ length: totalPages }, (_, i) => (
																<button
																	key={i + 1}
																	className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
																	onClick={() => handlePageChange(i + 1)}
																>
																	{i + 1}
																</button>
															)).slice(
																Math.max(0, currentPage - 3),
																Math.min(currentPage + 2, totalPages)
															)}

															<button
																className={`btn btn-sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'}`}
																onClick={() => handlePageChange(currentPage + 1)}
																disabled={currentPage === totalPages}
															>
																Next
															</button>
														</div>
													</div>

													<div className="g">
														<div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
															<div>Showing</div>
															<div>
																<select
																	className="form-select js-select2"
																	value={itemsPerPage}
																	onChange={handleItemsPerPageChange}
																>
																	<option value="10">10</option>
																	<option value="20">20</option>
																	<option value="50">50</option>
																	<option value="100">100</option>
																</select>
															</div>
															<div>of {count} items</div>
														</div>
													</div>
												</div>
											)}
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Page Onload Open Modal */}
			<div className="modal fade" tabIndex="-1" id="instructionModal">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Instruction </h5>
							<a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
								<em className="icon ni ni-cross-c"></em>
							</a>
						</div>
						<div className="modal-body inputCardBox">
							<div className="row">
								<div className="col-md-12 mb-3">
									<h6 className="instructionHeading">When ordering, please note "Specialty Coats and Accessories" No BOYS sizes available. Due to limited sizes and inventory, please call customer service to place orders for the styles listed below.
										<b>1-800-236-7303 </b>ext.
									</h6>
									<ul className="listIntruction">
										<li>951 - MOD Starlight Lame Silver</li>
										<li>952 - MOD Equinox Black Velvet</li>
										<li>953 - MOD Starlight Lame Blue</li>
										<li>954 - Allure Men Venice Dusty Rose</li>
										<li>956 - Ike Behar Carter Red</li>
										<li>957 - Allure Men Venice Aubergine Velvet</li>
										<li>959 - MOD Camo Lame Black & Gold</li>
										<li>961 - MOD Starlight Lame Stone</li>
										<li>963 - MOD Hendrix Multi-Color</li>
										<li>969 - MOD Ryan Multi-Color Floral</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Add Filter Modal */}
			<div className="modal fade" tabIndex="-1" id="addFilterModal">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">Add Filters</h5>
							<a href="#" className="close" data-bs-dismiss="modal" aria-label="Close">
								<em className="icon ni ni-cross-c"></em>
							</a>
						</div>
						<div className="modal-body inputCardBox">
							<div className="row">
								<div className="col-md-4 mb-3">
									<label>Where</label>
									<input type="date" className="" placeholder="Event date" />
								</div>
								<div className="col-md-4 mb-3 form-control-select">
									<label>Is</label>
									<select className=""><option>Select contain</option></select>
								</div>
								<div className="col-md-4 mb-3">
									<label>Date</label>
									<input type="date" className="" placeholder="Select date" />
								</div>
							</div>
							<div className="row mt-3">
								<div className="col-md-4 mb-3">
									<button type="submit" className="addBtnCustomer">Submit</button>
								</div>
								<div className="col-md-4 mb-3">
									<button type="submit" className="addMore">+ Add More</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Container >
	)
}

export default Wedding